module.exports = __webpack_public_path__ + "img/right.efe36889.svg";